import {
  IonButton,
  IonButtons,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonModal,
  IonText,
} from '@ionic/react';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import Contact from '@/assets/icons/contact.svg';
import ContactSelected from '@/assets/icons/contact-selected.svg';
import Exit from '@/assets/icons/exit.svg';
import Learning from '@/assets/icons/learning.svg';
import LearningSelected from '@/assets/icons/learning-selected.svg';
import ArrowSelector from '@/assets/icons/menu-selector-arrow-right.svg';
import MenuSelected from '@/assets/icons/menu-selector-arrow-right-red.svg';
import Operations from '@/assets/icons/operations.svg';
import OperationsSelected from '@/assets/icons/operations-selected.svg';
import Plugin from '@/assets/icons/plugin.webp';
import PluginSelected from '@/assets/icons/plugin-selected.svg';
import PlusIcon from '@/assets/icons/plus.svg';
import Profile from '@/assets/icons/profile.svg';
import ProfileSelected from '@/assets/icons/profile-selected.svg';
import Reporting from '@/assets/icons/reports.svg';
import ReportingSelected from '@/assets/icons/reports-selected.svg';
import Pepper from '@/assets/imgs/pepper.webp';
import OperationManged from '@/components/operations/ManagedModal/OperationManaged';
import { ROUTES_PATH } from '@/constants';
import ENVIRONMENT from '@/environments/environment';
import useModal from '@/hooks/useModal';
import { ClientTaxonomyEvents } from '@/interfaces/AnalyticsInterface/AnalyticsInterface';
import Session from '@/pages/Session/Session';
import { postLeads } from '@/redux/auth/authAPI';
import {
  checkmanagedOffers, checkpreferredOfferAndNoPreferredOffer, checkValueShowSelect, existingCommercialOffers, existingEcoOffers,
} from '@/redux/commercialOffers/commercialOffers';
import { saveVersionControl } from '@/redux/configOptions/config';
import { clearEcommercePlatformData } from '@/redux/ecommerceWidget/ecommerceWidget';
import { addError } from '@/redux/error/error';
import { clearFiltersSaved, saveCartId, saveNameOrDni } from '@/redux/filters/filters';
import { existingCartId } from '@/redux/invoiceManaged/cartIdManaged';
import { saveMerchantData } from '@/redux/merchant/merchant';
import { clearIsPreferredOffer } from '@/redux/orderManaged/orderManaged';
import { clearMonthSummaries, saveSettlements } from '@/redux/reporting/reporting';
import { Analytics } from '@/services/analytics';
import InsightService from '@/services/insights';
import TokenService from '@/services/token';
import { RootState } from '@/store';

import sytlesDashboard from '../../../pages/Operations/OperationsDashboard/OperationsDashboard.module.scss';
import styles from './Menu.module.scss';
import { fileOpenerService } from '@/services/fileOpener';

interface AppPage {
  url?: string;
  src: string;
  title: string;
  srcSelected: string;
  id?: string;
}

const {
  OPERATION_DASHBOARD,
  LEARNING,
  PROFILE,
  CONTACT,
  REPORTING,
  PLUGIN,
} = ROUTES_PATH;

const appPrincipalPages: AppPage[] = [
  {
    title: 'Operaciones',
    url: OPERATION_DASHBOARD,
    src: Operations,
    srcSelected: OperationsSelected,
    id: 'menu-item-operations',
  },
  {
    title: 'Reporting',
    url: REPORTING,
    src: Reporting,
    srcSelected: ReportingSelected,
    id: 'menu-item-reporting',
  },
  {
    title: 'Formación',
    url: LEARNING,
    src: Learning,
    srcSelected: LearningSelected,
    id: 'menu-item-learning',
  },
  {
    title: 'Plugin',
    url: PLUGIN,
    src: Plugin,
    srcSelected: PluginSelected,
    id: 'menu-item-plugin',
  },
  // {
  //   title: "Notificaciones",
  //   url: NOTIFICATIONS,
  //   src: Notifications,
  // },
];

const appUserPages: AppPage[] = [
  {
    title: 'Mi perfil',
    url: PROFILE,
    src: Profile,
    srcSelected: ProfileSelected,
    id: 'menu-item-profile',
  },
  {
    title: 'Ayuda y Contacto',
    url: CONTACT,
    src: Contact,
    srcSelected: ContactSelected,
    id: 'menu-item-contact',
  },
];
export default function Menu() {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const newSearchParams = new URLSearchParams(location.search);

  const [showModal, setShowModal] = useState(false);

  const { presentModal: presentManagedModal, dismissModal: dismissManagedModal } = useModal(OperationManged);
  const [newOperationModalOpen, setNewOperationModalOpen] = useState(false);
  const [pepperOneUrl, setPepperOneUrl] = useState('');
  const commercialOffersFound = useSelector(
    (state: RootState) => state.commercialOffers.data.commercialOffersFound,
  );
  const ECOcommercialOffers = useSelector(
    (state: RootState) => state.commercialOffers.data.existingEcoOffers,
  );
  const checkManaged = useSelector(
    (state: RootState) => state.commercialOffers.data.checkmanagedOffers,
  );
  const allowedOrigins = [
    ENVIRONMENT.URL_ECOMMERCE,
    ENVIRONMENT.URL_ECOMMERCE_2,
    ENVIRONMENT.URL_ECO,
    ENVIRONMENT.URL_ECO_2,
  ];
  const getLead = async (): Promise<string | undefined> => {
    try {
      const leadsResponse = await postLeads();
      sessionStorage.setItem('leadToken', leadsResponse?.data.token);
      const expirationDate = new Date();
      expirationDate.setSeconds(
        expirationDate.getSeconds() + leadsResponse?.data.expires_in,
      );
      sessionStorage.setItem('expiresLeads', expirationDate.toUTCString());
      return leadsResponse?.data.token;
    } catch (err) {
      dispatch(addError(''));
    }
  };

  const handleNewOperation = async () => {
    const lead_token = sessionStorage.getItem('leadToken');
    const lead_token_expiration = sessionStorage.getItem('expiresLeads');
    const currentTime = new Date();
    if (
      lead_token
      && lead_token_expiration
      && new Date(lead_token_expiration) > currentTime
    ) {
      setPepperOneUrl(
        `${ENVIRONMENT.URL_PEPPERONE}/?lead_token=${lead_token}&shared_offers=true`,
      );
      setNewOperationModalOpen(true);
      window.addEventListener('message', listener, false);
    } else {
      const tokenResponse = await getLead();
      if (tokenResponse) {
        setPepperOneUrl(
          `${ENVIRONMENT.URL_PEPPERONE}/?lead_token=${tokenResponse}&shared_offers=true`,
        );
        setNewOperationModalOpen(true);
        window.addEventListener('message', listener, false);
      } else {
        dispatch(addError(''));
      }
    }
    Analytics.registerAnalyticsEvent({ [ClientTaxonomyEvents.OPEN_PEPPERONE]: { type: 'NEW' } });
  };
  const handleNewOperationManaged = async () => {
    window.addEventListener('message', listenerManaged, false);
    presentManagedModal({
      useCanDismiss: true,
      onDismiss: () => {
        const newSearchParams = new URLSearchParams(location.search);
        newSearchParams.set('reload', 'true');
      },
    });

    sessionStorage.removeItem('retaken-eco');
    const lead_token = sessionStorage.getItem('leadToken');
    const lead_token_expiration = sessionStorage.getItem('expiresLeads');
    const currentTime = new Date();
    if (
      !lead_token
      || !lead_token_expiration
      || (lead_token
        && lead_token_expiration
        && new Date(lead_token_expiration) < currentTime)
    ) {
      await getLead();
    }
  };
  const sendTermsData = () => {
    const pepperOneIframe = document.getElementById(
      'pepper-one-iframe-menu',
    ) as HTMLIFrameElement;
    if (pepperOneIframe?.contentWindow) {
      const commercialOffersStored = sessionStorage.getItem(
        'pepperSimulationCommercialOffers',
      );
      commercialOffersStored
        && pepperOneIframe.contentWindow.postMessage(
          {
            simulationCommercialOffers: JSON.parse(commercialOffersStored),
          },
          '*',
        );
    }
  };

  const listener = (event: any) => {
    if (event.origin === ENVIRONMENT.URL_PEPPERONE && event.data?.message === 'close CEX') {
      setNewOperationModalOpen(false);
      newSearchParams.set('reload', 'true');
      window.removeEventListener('message', listener);
    }
  };

  useEffect(() => {
    const lead_token = sessionStorage.getItem('leadToken');
    setPepperOneUrl(`${ENVIRONMENT.URL_PEPPERONE}/?lead_token=${lead_token}&shared_offers=true`);

    return () => {
      window.removeEventListener('message', listener);
    };
  }, []);
  const listenerManaged = (event: any) => {
    if (allowedOrigins.includes(event.origin) && event.data?.message === 'close iframe') {
      dismissManagedModal();
      const newSearchParams = new URLSearchParams(location.search);
      newSearchParams.set('reload', 'true');
      window.removeEventListener('message', listenerManaged);
    } else if (allowedOrigins.includes(event.origin) && event.data?.message === 'Pepper - Signature Contract') {
      fileOpenerService.openContract(event.data.contractString);
    }
  };

  useEffect(() => () => {
    window.removeEventListener('message', listenerManaged);
  }, []);

  useEffect(() => {
    InsightService.logPageView(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    InsightService.logTrace('Pepper One - Modal', [{ Scope: 'PEPPER_ONE' }]);
  }, [newOperationModalOpen]);

  return (
    <IonMenu
      contentId="main"
      type="overlay"
      className={classNames(styles.menu, styles.menuPaneVisible)}
      // className="menu menu-pane-visible"
      hidden={
        location.pathname.includes('login')
        || location.pathname.includes('reset-password')
        || location.pathname.includes('change-password')
        || location.pathname.includes('privacy-policy')
        || location.pathname.includes('terms-of-use')
        || location.pathname.includes('actualiza-datos-seguridad-social')
        || location.pathname.includes('alta-cl')
        || location.pathname.includes('onboarding')
      }
      swipeGesture={false}
    >
      <div className={styles.menuWrapper}>
        <IonList id="menuList" className={styles.menuList}>
          <IonListHeader className={styles.logoWrapper}>
            <IonImg className={styles.pepperImg} src={Pepper} alt="Pepper" />
          </IonListHeader>
          <div className={styles.inboxListSection}>
            {appPrincipalPages.map((appPage) => {
              if (
                (appPage.title !== 'Nueva Operación'
                  || commercialOffersFound)
                && (appPage.title !== 'Pepper One' || commercialOffersFound)
                && (appPage.title !== 'Plugin' || (appPage.title === 'Plugin' && ECOcommercialOffers))
              ) {
                return (
                  <IonMenuToggle
                    key={appPage.title}
                    autoHide={false}
                    className={styles.menuSections}
                  >
                    <IonItem
                      id={appPage.id}
                      className={
                        (location.pathname === appPage.url
                          && !newOperationModalOpen)
                          || (newOperationModalOpen && !appPage.url)
                          ? `${`selected ${appPage.title}`}`
                          : ''
                      }
                      routerLink={appPage.url}
                      routerDirection="none"
                      lines="none"
                      detail={false}
                      onClick={() => !appPage.url && handleNewOperation()}
                    >
                      <IonImg
                        className={styles.imgs}
                        src={
                          (location.pathname === appPage.url
                            && !newOperationModalOpen)
                            || (newOperationModalOpen && !appPage.url)
                            ? appPage.srcSelected
                            : appPage.src
                        }
                      />
                      <IonLabel
                        className={`${(location.pathname === appPage.url
                          && !newOperationModalOpen)
                          || (newOperationModalOpen && !appPage.url)
                          ? styles.menuItemSelected
                          : styles.menuItem
                          }`}
                      >
                        {appPage.title}
                      </IonLabel>
                      <IonIcon
                        hidden={!((location.pathname === appPage.url
                          && !newOperationModalOpen)
                          || (newOperationModalOpen && !appPage.url))}
                        src={MenuSelected}
                        className={styles.menuSelectedIcon}
                      />
                    </IonItem>
                  </IonMenuToggle>
                );
              }
            })}
            <div className={styles.menuDivider} />
          </div>
          <div className={styles.inboxListSection}>
            {appUserPages.map((appPage) => (

              <IonMenuToggle key={appPage.title} autoHide={false}>
                <IonItem
                  id={appPage.id}
                  className={
                    location.pathname === appPage.url
                      ? `${`selected ${appPage.title}`}`
                      : ''
                  }
                  routerLink={appPage.url}
                  routerDirection="none"
                  lines="none"
                  detail={false}
                >
                  <IonImg
                    className={styles.imgs}
                    src={
                      (location.pathname === appPage.url
                        && !newOperationModalOpen)
                        || (newOperationModalOpen && !appPage.url)
                        ? appPage.srcSelected
                        : appPage.src
                    }
                  />
                  <IonLabel
                    className={`${(location.pathname === appPage.url
                      && !newOperationModalOpen)
                      || (newOperationModalOpen && !appPage.url)
                      ? styles.menuItemSelected
                      : styles.menuItem
                      }`}
                  >
                    {appPage.title}
                  </IonLabel>
                  <IonIcon
                    hidden={!((location.pathname === appPage.url
                      && !newOperationModalOpen)
                      || (newOperationModalOpen && !appPage.url))}
                    src={MenuSelected}
                    className={styles.menuSelectedIcon}
                  />
                </IonItem>
              </IonMenuToggle>
            ))}
            <div className={styles.menuDivider} />
            {(commercialOffersFound || checkManaged) && (
              <div className={styles.menuInfoActionsButtons}>
                <IonButtons
                  className={styles.menuInfoActionsIonbutton}
                  onClick={() => (checkManaged ? handleNewOperationManaged() : handleNewOperation())}
                >
                  <IonButton
                    className={styles.menuInfoActionsButtonsNewoperation}
                    expand="block"
                  >
                    <IonText>Nueva Operación</IonText>
                    <IonIcon src={PlusIcon} className={styles.menuInfoActionsIcon} />
                  </IonButton>
                </IonButtons>
              </div>
            )}
            <div className={styles.sidebarImgBg} />
            <IonMenuToggle
              className={styles.closeSessionSection}
              key="Cerrar sesión"
              autoHide={false}
            >
              <IonItem
                className={styles.closeItem}
                onClick={() => setShowModal(true)}
                routerDirection="none"
                lines="none"
                detail={false}
              >
                <IonImg className={styles.imgs} src={Exit} />
                <IonLabel className={styles.menuItem}>Cerrar sesión</IonLabel>
                <IonIcon src={ArrowSelector} className={styles.menuSessionIcon} />
              </IonItem>
            </IonMenuToggle>
          </div>
        </IonList>
      </div>
      <Session
        showModal={showModal}
        closeModal={() => setShowModal(false)}
        handleLogout={() => {
          TokenService.clearSession();
          Analytics.registerAnalyticsEvent({ [ClientTaxonomyEvents.LOGOUT]: {} });
          dispatch(saveSettlements([]));
          dispatch(clearMonthSummaries());
          dispatch(saveNameOrDni(''));
          dispatch(saveCartId(''));
          dispatch(clearFiltersSaved());
          dispatch(saveMerchantData(null));
          history.push(ROUTES_PATH.LOGIN);
          dispatch(existingCommercialOffers(false));
          dispatch(existingEcoOffers(false));
          dispatch(existingCartId(false));
          dispatch(checkmanagedOffers(false));
          dispatch(checkpreferredOfferAndNoPreferredOffer(false));
          dispatch(checkValueShowSelect(false));
          dispatch(clearIsPreferredOffer());
          dispatch(clearEcommercePlatformData());
          dispatch(saveVersionControl(undefined));
          sessionStorage.removeItem("Pepper-AlertDismissed");
          setShowModal(false);
        }}
      />
      <IonModal
        isOpen={newOperationModalOpen}
        backdropDismiss={false}
        id="pepper-one-modal"
        onDidDismiss={() => setNewOperationModalOpen(false)}
        className={sytlesDashboard.pepperOneModal}
      >
        <iframe
          src={pepperOneUrl}
          id="pepper-one-iframe-menu"
          className={sytlesDashboard.pepperIframe}
          title="pepperone"
          allow="microphone; camera; midi; encrypted-media;"
          width="100%"
          height="100%"
          onLoad={sendTermsData}
        />
      </IonModal>
    </IonMenu>
  );
}
